import { CheckName } from 'dashboard/models/check/check';
import { RequiredProperty } from 'dashboard/models/check/government-id';
import { VerificationCheckConfig } from 'dashboard/models/verification-check-config/verification-check-config';
import { GovernmentIdClass } from 'lib/constants/governmentIds';

export type ExtractionCheckName = CheckName.IdExtractedPropertiesDetection;

export interface RequiredPropertyConfig {
  'id-class': GovernmentIdClass | 'default';
  'country-code': string;
  properties: RequiredProperty[];
}

export interface ExtractionCheckConfig extends VerificationCheckConfig {
  name: ExtractionCheckName;
  'required-properties': RequiredPropertyConfig[];
}
// Reference: https://www.notion.so/withpersona/Verification-Check-Configs-f3e5dadc981f4fcba4593d1624f7842d

export function isExtractionCheck(
  verificationCheck: VerificationCheckConfig,
): verificationCheck is ExtractionCheckConfig {
  switch (verificationCheck.check) {
    case CheckName.IdExtractedPropertiesDetection:
      return true;
    default:
      return false;
  }
}
